/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  generateAiAgentSummary(conversationID) {
    return axios.post(`${this.url}/${conversationID}/ai_agent/summary`);
  }

  dispatchAiAgent(conversationID, instructions) {
    return axios.post(`${this.url}/${conversationID}/ai_agent/dispatch`, {
      envio: instructions,
    });
  }

  getUnreadCounts() {
    return axios.get(`${this.url}/unread_counts`);
  }
}

export default new ConversationApi();
